// @ts-nocheck
/* eslint-disable no-extend-native */
/* Chrome 47 polyfills — carregar antes de qualquer outro módulo */
export {};

// Normalize legacy KeyboardEvent.key names (Chrome <51 used "Up", "Down", "Esc", etc.)
// Also fills in event.key from keyCode when key is missing (Chrome 47 on Samsung remotes).
// Intercepts in capture phase before any React handler sees the event.
(function normalizeKeyNames() {
  var KEY_MAP = {
    'Up': 'ArrowUp',
    'Down': 'ArrowDown',
    'Left': 'ArrowLeft',
    'Right': 'ArrowRight',
    'Esc': 'Escape',
    'Del': 'Delete',
    'Spacebar': ' ',
  };
  // keyCode → key for when key is empty/undefined (old Samsung Tizen remotes)
  var KEYCODE_MAP = {
    37: 'ArrowLeft',
    38: 'ArrowUp',
    39: 'ArrowRight',
    40: 'ArrowDown',
    13: 'Enter',
    27: 'Escape',
    8: 'Backspace',
    32: ' ',
    46: 'Delete',
    10009: 'BrowserBack', // Samsung remote Back button
    461: 'BrowserBack',   // LG webOS Back button
  };
  function patchKey(e, value) {
    try { Object.defineProperty(e, 'key', { value: value, configurable: true, writable: true }); } catch (err) {}
  }
  document.addEventListener('keydown', function (e) {
    if (!e.key || e.key === 'Unidentified') {
      var fromCode = KEYCODE_MAP[e.keyCode];
      if (fromCode) patchKey(e, fromCode);
      return;
    }
    var mapped = KEY_MAP[e.key];
    if (mapped) patchKey(e, mapped);
  }, true);
})();

// Object.getOwnPropertyDescriptors (Chrome 54+)
if (typeof Object.getOwnPropertyDescriptors === 'undefined') {
  Object.getOwnPropertyDescriptors = function (obj) {
    var result = {};
    Object.getOwnPropertyNames(obj).forEach(function (name) {
      result[name] = Object.getOwnPropertyDescriptor(obj, name);
    });
    return result;
  };
}

// Promise.finally (Chrome 63+)
if (typeof Promise !== 'undefined' && !Promise.prototype.finally) {
  Promise.prototype.finally = function (onFinally) {
    return this.then(
      function (value) {
        return Promise.resolve(
          typeof onFinally === 'function' ? onFinally() : undefined
        ).then(function () { return value; });
      },
      function (reason) {
        return Promise.resolve(
          typeof onFinally === 'function' ? onFinally() : undefined
        ).then(function () { throw reason; });
      }
    );
  };
}

// Promise.allSettled (Chrome 76+)
if (typeof Promise !== 'undefined' && !Promise.allSettled) {
  Promise.allSettled = function (promises) {
    return Promise.all(
      promises.map(function (p) {
        return Promise.resolve(p).then(
          function (value) { return { status: 'fulfilled', value: value }; },
          function (reason) { return { status: 'rejected', reason: reason }; }
        );
      })
    );
  };
}

// Object.values (Chrome 54+)
if (!Object.values) {
  Object.values = function (obj) {
    return Object.keys(obj).map(function (k) { return obj[k]; });
  };
}

// Object.entries (Chrome 54+)
if (!Object.entries) {
  Object.entries = function (obj) {
    return Object.keys(obj).map(function (k) { return [k, obj[k]]; });
  };
}

// Object.fromEntries (Chrome 73+)
if (!Object.fromEntries) {
  Object.fromEntries = function (iterable) {
    var obj = {};
    var arr = Array.isArray(iterable) ? iterable : Array.from(iterable);
    for (var i = 0; i < arr.length; i++) {
      obj[arr[i][0]] = arr[i][1];
    }
    return obj;
  };
}

// String.prototype.padStart (Chrome 57+)
if (!String.prototype.padStart) {
  String.prototype.padStart = function (targetLength, padString) {
    padString = String(padString !== undefined ? padString : ' ');
    var str = String(this);
    if (padString.length === 0) return str;
    while (str.length < targetLength) { str = padString + str; }
    return str.slice(-targetLength);
  };
}

// String.prototype.padEnd (Chrome 57+)
if (!String.prototype.padEnd) {
  String.prototype.padEnd = function (targetLength, padString) {
    padString = String(padString !== undefined ? padString : ' ');
    var str = String(this);
    if (padString.length === 0) return str;
    while (str.length < targetLength) { str = str + padString; }
    return str.slice(0, targetLength);
  };
}

// String.prototype.replaceAll (Chrome 85+)
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (searchValue, replaceValue) {
    if (typeof searchValue === 'string') {
      return this.split(searchValue).join(replaceValue);
    }
    return this.replace(searchValue, replaceValue);
  };
}

// String.prototype.trimEnd / trimStart (Chrome 66+)
if (!String.prototype.trimEnd) {
  String.prototype.trimEnd = function () {
    return this.replace(/\s+$/, '');
  };
}
if (!String.prototype.trimStart) {
  String.prototype.trimStart = function () {
    return this.replace(/^\s+/, '');
  };
}

// Array.prototype.flat (Chrome 69+)
if (!Array.prototype.flat) {
  Array.prototype.flat = function (depth) {
    depth = depth === undefined ? 1 : Math.floor(depth);
    var flatten = function (arr, d) {
      return d > 0
        ? arr.reduce(function (acc, val) {
            return acc.concat(Array.isArray(val) ? flatten(val, d - 1) : val);
          }, [])
        : arr.slice();
    };
    return flatten(this, depth);
  };
}

// Array.prototype.flatMap (Chrome 69+)
if (!Array.prototype.flatMap) {
  Array.prototype.flatMap = function (cb) {
    return Array.prototype.map.call(this, cb).flat(1);
  };
}

// Array.from (Chrome 45+) — já suportado no Chrome 47, mas garantir
if (!Array.from) {
  Array.from = function (arrayLike, mapFn) {
    var arr = [];
    for (var i = 0; i < arrayLike.length; i++) {
      arr.push(mapFn ? mapFn(arrayLike[i], i) : arrayLike[i]);
    }
    return arr;
  };
}

// scrollIntoView({block:...}) options support (Chrome 61+)
// Chrome 47 ignores the options object and scrolls to the top.
// This patch implements 'nearest', 'start', 'end', 'center' manually.
(function patchScrollIntoView() {
  if (typeof Element === 'undefined' || !Element.prototype.scrollIntoView) return;
  var _orig = Element.prototype.scrollIntoView;
  function getScrollParent(el) {
    var p = el.parentElement;
    while (p && p !== document.body) {
      try {
        var s = window.getComputedStyle(p);
        var oy = s.overflowY || s.overflow || '';
        if (oy === 'auto' || oy === 'scroll') return p;
      } catch (e) {}
      p = p.parentElement;
    }
    return null;
  }
  Element.prototype.scrollIntoView = function scrollIntoView(arg) {
    if (!arg || typeof arg !== 'object') {
      _orig.call(this, arg);
      return;
    }
    var block = arg.block || 'start';
    var container = getScrollParent(this);
    if (!container) { _orig.call(this, true); return; }
    var elRect = this.getBoundingClientRect();
    var ctRect = container.getBoundingClientRect();
    var ctH = container.clientHeight;
    if (block === 'start') {
      container.scrollTop += elRect.top - ctRect.top;
    } else if (block === 'end') {
      container.scrollTop += elRect.bottom - ctRect.bottom;
    } else if (block === 'center') {
      container.scrollTop += (elRect.top - ctRect.top) - (ctH - elRect.height) / 2;
    } else { // 'nearest'
      if (elRect.top < ctRect.top) {
        container.scrollTop += elRect.top - ctRect.top;
      } else if (elRect.bottom > ctRect.bottom) {
        container.scrollTop += elRect.bottom - ctRect.bottom;
      }
    }
  };
})();

// globalThis (Chrome 71+)
if (typeof globalThis === 'undefined') {
  (function () {
    var g = (typeof window !== 'undefined' ? window :
             typeof global !== 'undefined' ? global : this); // eslint-disable-line no-invalid-this
    if (g) { Object.defineProperty(g, 'globalThis', { value: g, writable: true, configurable: true }); }
  })();
}
